import SectionWithSmallIcons from './section-with-small-icons';

export default SectionWithSmallIcons;
